module.exports = __webpack_public_path__ + "img/G.c5226cd0.webp";